import './App.css';
import Navbar from "./components/navbar/navbar";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from "./components/home";

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hardware" element={<Navigate to="/hardware/home" replace />} />
          <Route path="/software" element={<Navigate to="/software/home" replace />} />
          
          {/* Hardware Routes */}
          <Route path="/hardware/home" element={<Home />} />
          <Route path="/hardware/pc" element={<Home />} />
          <Route path="/hardware/laptop" element={<Home />} />
          <Route path="/hardware/components" element={<Home />} />
          <Route path="/hardware/networking" element={<Home />} />
          
          {/* Software Routes */}
          <Route path="/software/home" element={<Home />} />
          <Route path="/software/products" element={<Home />} />
          <Route path="/software/antivirus" element={<Home />} />
          <Route path="/software/tools" element={<Home />} />
          <Route path="/software/support" element={<Home />} />
          
          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
